import Swal from 'sweetalert2';
import { authHeader } from './authHeader';

var url_json = require("../location.json");

if (window.location.origin.includes("localhost")) {
    url_json = url_json.local;
} else {
    url_json = url_json.production;
}

// Sin _id, timestamps ni deletedAt: la API rechaza campos fuera del DTO
const cuerpoProfesor = data => ({
    nombre: data.nombre.trim(),
    tipo: Number(data.tipo),
    categoria: data.categoria ?? '',
    materias: data.materias ?? '',
    orden: Number(data.orden) || 0,
    archivo: data.archivo
});

const Profesores = {
    agregarProfesor: async (data) => {
        let url = url_json + "/profesor"
        let body = cuerpoProfesor(data);

        let request = {
            method: 'POST',
            body: JSON.stringify(body),
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let res = await response.json();

        if (response.ok) {
            Swal.fire(
              'Inserción exitosa!',
              'Profesor agregado correctamente' ,
              'success'
            )
        } else {
            Swal.fire(
                'Error!',
                'No se pudo guardar el profesor, codigo: ' + res.message ,
                'error'
            )
        }
        return { success: response.ok, data: res.data, code: res.message };
    },
    obtenerProfesores: async () => {
        let url = url_json + "/profesor"
        let request = {
            method:'GET',
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    editarProfesor: async (data, id) => {
        let url = url_json + "/profesor/" + id;

        let body = cuerpoProfesor(data);
        let request = {
            method: 'PATCH',
            body: JSON.stringify(body),
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let res = await response.json();
        if (response.ok) {
            Swal.fire(
                'Modificación exitosa!',
                'Profesor modificado correctamente' ,
                'success'
            )
        } else {
            Swal.fire(
                'Error!',
                'No se pudo modificar el profesor' ,
                'error'
            )
        }
        return { success: response.ok, data: res.data };
    },
    eliminarProfesor: async id => {
        let url = url_json + "/profesor/delete/" + id;
        let request = {
            method: 'PATCH',
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let res = await response.json();
        if (response.ok) {
            Swal.fire(
                'Eliminación exitosa!',
                'Profesor eliminado correctamente' ,
                'success'
            )
        } else {
            Swal.fire(
                'Error!',
                'No se pudo eliminar el profesor',
                'error'
            )
        }
        return { success: response.ok, data: res.data };
    }
}

export default Profesores;
